import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAb0X36LCZUAa0uExSWROrRDKT7cPW0LlE",
  authDomain: "probroker-4a749.firebaseapp.com",
  projectId: "probroker-4a749",
  storageBucket: "probroker-4a749.firebasestorage.app",
  messagingSenderId: "345802283788",
  appId: "1:345802283788:web:cee1c79d912ff4bdff0729",
  measurementId: "G-X5VCW0RQZV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Push sirf live site pe chalega. Localhost bhi live Firebase project use karta hai,
// isliye wahan bana token live users ki notifications dev machine pe le aata hai.
const isLocalhost = () =>
  ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

// Localhost pe pehle se registered FCM worker hata do, taaki purana token bhi mar jaaye
if (isLocalhost() && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => {
        const worker = registration.active || registration.waiting || registration.installing;
        if (worker && worker.scriptURL.includes('firebase-messaging-sw.js')) {
          registration.unregister();
        }
      });
    })
    .catch(() => {});
}

// Check if notifications are supported
const isNotificationSupported = () => {
  if (isLocalhost()) return false;
  return 'Notification' in window && 'serviceWorker' in navigator;
};

const messagingSupported = async () => {
  if (isLocalhost()) return false;
  try {
    return await isSupported();
  } catch {
    return false;
  }
};

// Get current notification permission status
const getNotificationPermissionStatus = () => {
  if (!isNotificationSupported()) {
    return 'not-supported';
  }
  return Notification.permission;
};

// Check if notifications are blocked
const areNotificationsBlocked = () => {
  return getNotificationPermissionStatus() === 'denied';
};

// Get browser-specific instructions for enabling notifications
const getNotificationInstructions = () => {
  const browser = detectBrowser();
  switch (browser) {
    case 'chrome':
      return 'To enable notifications, click the lock icon in the address bar and allow notifications for this site.';
    case 'firefox':
      return 'To enable notifications, click the shield icon in the address bar and allow notifications for this site.';
    case 'safari':
      return 'To enable notifications, go to Safari Preferences > Websites > Notifications and allow notifications for this site.';
    default:
      return 'To enable notifications, please check your browser settings and allow notifications for this site.';
  }
};

// Detect browser
const detectBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes('chrome')) return 'chrome';
  if (userAgent.includes('firefox')) return 'firefox';
  if (userAgent.includes('safari')) return 'safari';
  return 'other';
};

// Register service worker
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/'
      });
      // console.log('Service Worker registered with scope:', registration.scope);
      return registration;
    } catch (error) {
      // console.error('Service Worker registration failed:', error);
      // throw error;
    }
  }
  // throw new Error('Service Worker not supported');
};

// Initialize messaging after service worker registration
const initializeMessaging = async () => {
  try {
    if (areNotificationsBlocked()) {
      throw new Error('notifications-blocked');
    }
    const supported = await messagingSupported();
    if (!supported) {
      throw new Error('messaging-unsupported');
    }

    const registration = await registerServiceWorker();
    const messaging = getMessaging(app);
    
    // Get the token
    const currentToken = await getToken(messaging, {
      vapidKey: "BA-Ziu85axr4ZW2Xf0ellzfh0GNkRBL9zvgls_sIlp4D-1FGMWRj1DknTA1W19k_Ijxq8hcQC_PEcscdGelGZys",
      serviceWorkerRegistration: registration
    });

    if (currentToken) {
      // console.log('Current FCM token:', currentToken);
      return { messaging, token: currentToken };
    } else {
      // console.log('No registration token available.');
      return { messaging, token: null };
    }
  } catch (error) {
    // console.error('Failed to initialize messaging:', error);
    throw error;
  }
};

// Request notification permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    if (!isNotificationSupported()) {
      throw new Error('notifications-not-supported');
    }
    const supported = await messagingSupported();
    if (!supported) {
      throw new Error('messaging-unsupported');
    }

    if (areNotificationsBlocked()) {
      throw new Error('notifications-blocked');
    }

    const { messaging, token } = await initializeMessaging();

    // Check if permission is already granted
   if (Notification.permission === 'granted') {
      return { token, permission: 'granted' };
    }

    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      return { token, permission: 'granted' };  // pehle se mila token use karo
    } else {
      return { token: null, permission: 'denied' };
    }
  } catch (error) {
    // console.error("Error getting notification permission:", error);
    return { 
      token: null, 
      permission: 'error', 
      error: error.message,
      instructions: error.message === 'notifications-blocked' ? getNotificationInstructions() : null
    };
  }
};

// Handle incoming messages when app is in foreground
export const onMessageListener = () =>
  new Promise((resolve) => {
    messagingSupported()
      .then((supported) => {
        if (!supported) {
          resolve(null);
          return;
        }
        initializeMessaging()
          .then(({ messaging }) => {
            onMessage(messaging, (payload) => {
              resolve(payload);
            });
          })
          .catch(() => {
            resolve(null);
          });
      });
  });

// Track user login
logEvent(analytics, 'login', {
  method: 'email'
});

// Track property view
logEvent(analytics, 'view_property', {
  property_id: '123',
  property_type: 'residential'
});

export { 
  analytics, 
  isNotificationSupported, 
  getNotificationPermissionStatus,
  areNotificationsBlocked,
  getNotificationInstructions
}; 
